import React, {useState, useEffect} from 'react';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import {Snackbar, SnackbarContent} from '@mui/material';

export default function SimpleSnackbar(props) {
  const {snackBarMessage, setSnackBarMessage} = props;
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (snackBarMessage) setOpen(true);
  }, [snackBarMessage]);

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setSnackBarMessage('');
    setOpen(false);
  };

  const action = (
    <React.Fragment>
      <IconButton
        size='small'
        aria-label='close'
        color='inherit'
        onClick={handleClose}
      >
        <CloseIcon fontSize='small' />
      </IconButton>
    </React.Fragment>
  );

  return (
    <div>
      <Snackbar open={open} onClose={handleClose} autoHideDuration={6000}>
        <SnackbarContent
          action={action}
          style={{
            marginBottom: '75px',
            backgroundColor: 'success.main',
            opacity: 0.95
          }}
          message={snackBarMessage}
        ></SnackbarContent>
      </Snackbar>
    </div>
  );
}
